/**
 * Help centre: three small tools. Words come from the page (section settings); nothing is typed here.
 *   <sunday-help-search>  filters the help articles by title or topic as you type
 *   <sunday-help-vote>    "Did this answer your question?": sends an analytics event; No shows WhatsApp and Call
 *   .sd-hvid buttons      a video still that loads YouTube only when tapped
 *   "Label: …" notes      a body paragraph opening with a bold label gets class sd-hnote
 */

// Help home (mockup v125): the search filters every answer card on the page; the topic chips jump and follow the scroll;
// an old topic address (/blogs/support/tagged/…) opens the page at its topic (data-jump).
const hub = document.querySelector('.sd-hx-browse');
if (hub) {
  const q = document.getElementById('sd-hx-q');
  const none = hub.querySelector('.sd-hx-none');
  const secs = [...hub.querySelectorAll('.sd-hx-sec')];
  const filter = () => {
    const words = (q.value || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
    let n = 0;
    for (const sec of secs) {
      let k = 0;
      for (const li of sec.querySelectorAll('.sd-hx-it')) {
        const ok = !words.length || (!sec.hasAttribute('data-most') && words.every((w) => li.dataset.q.includes(w)));
        li.hidden = !ok;
        if (ok) { k++; if (!sec.hasAttribute('data-most')) n++; }
      }
      sec.hidden = k === 0;
    }
    if (none) none.hidden = !words.length || n > 0;
  };
  const toFirst = () => {
    const s = secs.find((x) => !x.hidden && !x.hasAttribute('data-most'));
    if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  if (q) {
    q.addEventListener('input', filter);
    q.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); q.blur(); toFirst(); } });
    document.querySelector('.sd-hx-go')?.addEventListener('click', toFirst);
  }
  // The chips sit under the site header (its height changes with the festive bar and the screen width).
  const head = document.querySelector('.sd-sh');
  const setTop = () => { if (head) hub.style.setProperty('--hx-top', (window.sdChrome ? window.sdChrome() : head.offsetHeight) + 'px'); };
  setTop();
  addEventListener('resize', setTop, { passive: true });
  const chips = [...hub.querySelectorAll('.sd-hx-chip')];
  const rail = hub.querySelector('.sd-hx-crail');
  let cur = '';
  const spy = () => {
    const nav = hub.querySelector('.sd-hx-chips').getBoundingClientRect();
    const line = (nav.width < innerWidth * 0.5 ? (head ? head.getBoundingClientRect().bottom : 0) + 40 : nav.bottom) + 24;
    let id = secs[0]?.id;
    for (const s of secs) if (!s.hidden && s.getBoundingClientRect().top <= line) id = s.id;
    if (id === cur) return;
    cur = id;
    for (const c of chips) {
      const on = c.getAttribute('href') === '#' + id;
      c.classList.toggle('is-on', on);
      if (on && rail.scrollWidth > rail.clientWidth + 2) rail.scrollTo({ left: c.offsetLeft - parseFloat(getComputedStyle(rail).paddingLeft), behavior: 'smooth' });
    }
  };
  // The page can scroll in the window or in Horizon's .page-wrapper: listen to both (capture).
  let tick = 0;
  document.addEventListener('scroll', () => { if (!tick) tick = setTimeout(() => { tick = 0; spy(); }, 60); }, { passive: true, capture: true });
  const j = hub.dataset.jump && document.getElementById(hub.dataset.jump);
  if (j) j.scrollIntoView({ block: 'start' });
  spy();
}

class SundayHelpVote extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-v]');
      if (!b) return;
      const v = b.dataset.v;
      try {
        window.Shopify?.analytics?.publish?.('sunday_help_vote', { article: this.dataset.article, answer: v });
      } catch (_) { /* analytics is optional */ }
      this.querySelector('[data-ask]').hidden = true;
      this.querySelector(v === 'yes' ? '[data-yes]' : '[data-no]').hidden = false;
    });
  }
}

// A paragraph that opens with a bold "Label:" and goes on is a note (e.g. "Important: …"): drawn as a soft box.
for (const p of document.querySelectorAll('.sd-hbody > p')) {
  const b = p.firstElementChild;
  if (b && p.firstChild === b && /^(STRONG|B)$/.test(b.tagName) && /:\s*$/.test(b.textContent) && p.textContent.trim().length > b.textContent.trim().length + 3) p.classList.add('sd-hnote');
}

document.addEventListener('click', (e) => {
  const b = e.target.closest('.sd-hvid[data-vid]');
  if (!b) return;
  const f = document.createElement('iframe');
  // The store sends Referrer-Policy: same-origin; YouTube refuses to play without a referrer (error 153).
  f.referrerPolicy = 'strict-origin-when-cross-origin';
  f.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(b.dataset.vid)}?autoplay=1&rel=0`;
  f.title = b.getAttribute('aria-label') || '';
  f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
  f.allowFullscreen = true;
  const w = document.createElement('div');
  w.className = 'sd-hvid';
  w.append(f);
  b.replaceWith(w);
});

if (!customElements.get('sunday-help-vote')) customElements.define('sunday-help-vote', SundayHelpVote);
